/* @flow strict */

import * as React from 'react';
import CollapsedPanel from '/client/src/components/panel/collapsedPanel';

type PropsType = {
  need_collect_demographic_data: boolean,
  need_collect_full_birth_day: boolean,
  handleChangeCheckbox: () => void,
  handleControlEventDemographic: () => void
};

const Demographic = (props: PropsType): React.Element<typeof React.Element> => {
  const [isCheckedBlock, checkedBlock] = React.useState(props.need_collect_demographic_data);
  const [withYear, _setWithYear] = React.useState(props.need_collect_full_birth_day);
  const [withoutYear, _setWithoutYear] = React.useState(!props.need_collect_full_birth_day);

  React.useEffect(() => {
    props.handleControlEventDemographic(isCheckedBlock, withYear);
  }, [isCheckedBlock, withYear, withoutYear]);

  const setWithYear = (status: boolean) => {
    _setWithYear(status);
    props.handleChangeCheckbox({
      target: {
        name: 'need_collect_full_birth_day',
        value: status
      }
    });
  };

  const setWithoutYear = (status: boolean) => {
    _setWithoutYear(status);
    props.handleChangeCheckbox({
      target: {
        name: 'need_collect_full_birth_day',
        value: status
      }
    });
  };

  return (
    <CollapsedPanel
      title='Collect demographic data'
      status={isCheckedBlock}
      onChange={(status: boolean): any => checkedBlock(status)}
    >
      <>
        <div className="form-group SimpleInput">
          <div className="row">
            <div className="col-sm-12">
              <label className="icheckbox" style={{ margin: '6px 0' }}>
                <input type="radio"
                  checked={withYear}
                  onChange={(e: any) => {
                    const isChecked = e.target.checked;

                    setWithYear(isChecked);

                    // emulate radio button
                    if (withoutYear) {
                      setWithoutYear(false);
                    }
                  }}
                />
                <i className="icheckbox-icon" />
                <span>Collect birthday date with a year</span>
              </label>
            </div>
            <div className="col-sm-12">
              <label className="icheckbox" style={{ margin: '6px 0' }}>
                <input type="radio"
                  checked={withoutYear}
                  onChange={(e: any) => {
                    const isChecked = e.target.checked;

                    setWithoutYear(isChecked);

                    // emulate radio button
                    if (withYear) {
                      setWithYear(false);
                    }
                  }}
                />
                <i className="icheckbox-icon" />
                <span>Collect birthday date without year</span>
              </label>
            </div>
          </div>
        </div>
      </>
    </CollapsedPanel>
  );
};

export default Demographic;
